import { toast } from "react-toastify";
import { removeToken } from "./tokenStorage";
import { removeUser } from "./userStorage";

export const handleLogout = async (setIsLogout: any, navigate: any) => {
  toast.success("You are logged out");
  setIsLogout(false);
  navigate("/");
  removeToken();
  removeUser();
};
